import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const SHOPTYPEPICKERBLOCK_LEGACY_FIELD_ORDER = [];

const {
  shopTypePickerBlockDescriptor: _generatedShopTypePickerBlockDescriptor,
  shopTypePickerBlockBlocDefinition,
  shopTypePickerBlockDashboardLayout,
  shopTypePickerBlockConfig,
  shopTypePickerBlockResolveConfig,
  shopTypePickerBlockProperties,
} = doodBlockConfig(
  {
    name: "Shop type picker",
    componentType: 'ShopTypePickerBlockComponent',
    category: 'catalog',
    description: "Shop type picker.",
    keywords: [],
    hideFromPicker: true,
    allowed_in: ["ShopSearchPage"],
    sharedFields: {}
  },

  () => ({
    // no scalar props
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: [],
          },
        ],
      },
    ],
  })
);

export function shopTypePickerBlockDescriptor(): IBlockDescriptor;
export function shopTypePickerBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function shopTypePickerBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedShopTypePickerBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedShopTypePickerBlockDescriptor, shopTypePickerBlockProperties, fieldOrder);
}

export {
  shopTypePickerBlockBlocDefinition,
  shopTypePickerBlockDashboardLayout,
  shopTypePickerBlockProperties,
  shopTypePickerBlockConfig,
  shopTypePickerBlockResolveConfig,
};

export type ShopTypePickerBlockConfig = typeof shopTypePickerBlockConfig;
